<script>
import { defineComponent, reactive, toRefs, onMounted } from 'vue-demi'
import service from '@/service/courseAndGroup'
import { debounce } from 'lodash'
export default defineComponent({
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      courseList: []
    })
    onMounted(() => {
      // getCourseList()
    })
    /**
     * @description 搜索课程
     */
    const onCourseSearch = debounce(function(val) {
      this.getCourseList(val)
    }, 500, { leading: false })
    /**
     * 设置课程列表
     */
    const setCourseList = courseList => {
      state.courseList = (courseList || []).map(item => ({
        ...item,
        id: `${item.classTypeId}`,
        name: item.itvCourseName,
        experience: item.experience,
        // 课程类型：1长线课\2短线课\3公开课
        classStyle: item.classStyle,
        cardType: item.cardType,
        sourceType: item.sourceType || 1,
        allowCiCard: item.allowCiCard
      }))
      emit('valChange', getSelectInfo())
    }
    /**
     * @description 课程列表
     */
    const getCourseList = (courseName, courseId) => {
      const param = { itvCourseName: courseName || '' }
      service.getCourseListByName(param).then(res => {
        setCourseList(courseId ? res.filter(r => r.classTypeId === courseId) : res)
      })
    }
    /**
     * 初始化课程列表
     */
    const initCourseList = (courseInfo, search) => {
      if (courseInfo && courseInfo.itvCourseName && !search) {
        setCourseList([courseInfo])
      } else {
        getCourseList(courseInfo && courseInfo.itvCourseName, courseInfo.classTypeId)
      }
    }
    const onSelectCourse = val => {
      emit('select', val)
    }
    const onChange = val => {
      emit('change', val)
      emit('valChange', state.courseList.find(k => k.id == val))
    }
    const onBlur = () => {
      if (!props.value) return
      const target = state.courseList.find(k => k.id == props.value)
      if (!target) emit('clearClassTypeId')
    }
    const getSelectInfo = () => {
      const selectInfo = state.courseList.find(k => k.id == props.value)
      return selectInfo
    }
    return {
      getSelectInfo,
      onBlur,
      ...toRefs(state),
      getCourseList,
      onCourseSearch,
      onSelectCourse,
      onChange,
      initCourseList
    }
  },
  render() {
    const dis = !!this.disabled
    // 选项
    const CustomItem = this.courseList.map((item, index) => (
      <a-select-option
        key={index}
        value={item.id}
        title={item.name}
      >
        { item.name }
      </a-select-option>
    ))
    return (
      <a-auto-complete
        value={this.value}
        placeholder="请选择学习机课程"
        option-label-prop="title"
        allow-clear
        disabled={dis}
        onBlur={this.onBlur}
        onsearch={this.onCourseSearch}
        onselect={this.onSelectCourse}
        onchange={this.onChange}
        >
        <template slot="dataSource">
          {CustomItem}
        </template>
      </a-auto-complete>
    )
  }
})
</script>
